import { SvgIcon, SvgIconProps } from '@mui/material';
import React, { ReactElement } from 'react';

export interface OutgoingMailIconProps extends SvgIconProps {}

export const OutgoingMailIcon = (
  props: OutgoingMailIconProps,
): ReactElement => {
  return (
    <SvgIcon {...props} viewBox="0 0 30 31">
      <mask
        id="mask0_1900_3189"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="30"
        height="31"
      >
        <rect y="0.5" width="30" height="30" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1900_3189)">
        <path
          d="M22.5 24.6106L21.6394 23.75L24.2091 21.125H18.125V19.875H24.2091L21.6394 17.25L22.5 16.3894L26.6106 20.5L22.5 24.6106ZM5.14437 21.125C4.58896 21.125 4.11354 20.9273 3.71813 20.5319C3.32271 20.1365 3.125 19.661 3.125 19.1056V6.89437C3.125 6.33896 3.32271 5.86354 3.71813 5.46812C4.11354 5.07271 4.58896 4.875 5.14437 4.875H21.1056C21.661 4.875 22.1365 5.07271 22.5319 5.46812C22.9273 5.86354 23.125 6.33896 23.125 6.89437V13.6537C23.0208 13.6442 22.9167 13.637 22.8125 13.6322C22.7083 13.6274 22.6042 13.625 22.5 13.625C22.3958 13.625 22.2917 13.6262 22.1875 13.6287C22.0833 13.631 21.9792 13.637 21.875 13.6466V7.05781L13 13.4806L4.375 7.065V19.1056C4.375 19.33 4.44708 19.5144 4.59125 19.6587C4.73562 19.8029 4.92 19.875 5.14437 19.875H15.6466C15.637 19.9792 15.631 20.0833 15.6287 20.1875C15.6263 20.2917 15.625 20.3958 15.625 20.5C15.625 20.6042 15.6274 20.7083 15.6322 20.8125C15.637 20.9167 15.6442 21.0208 15.6538 21.125H5.14437ZM5.17781 6.125L13 11.9569L21.0578 6.125H5.17781Z"
          fill="currentColor"
        />
      </g>
    </SvgIcon>
  );
};
